import { RandomGenerator } from "../test-utils";
import { AccountInfoBuilder } from "./account-Info.builder";
var UserAccountInfoBuilder = /** @class */ (function () {
    function UserAccountInfoBuilder() {
        this.userAccountInfo = {
            accountInfo: new AccountInfoBuilder().build(),
            email: RandomGenerator.randomString(),
            id: RandomGenerator.id(),
            username: RandomGenerator.randomName(),
        };
    }
    UserAccountInfoBuilder.prototype.withAccountInfo = function (accountInfo) {
        this.userAccountInfo.accountInfo = accountInfo;
        return this;
    };
    UserAccountInfoBuilder.prototype.withEmail = function (email) {
        this.userAccountInfo.email = email;
        return this;
    };
    UserAccountInfoBuilder.prototype.withId = function (id) {
        this.userAccountInfo.id = id;
        return this;
    };
    UserAccountInfoBuilder.prototype.withUsername = function (username) {
        this.userAccountInfo.username = username;
        return this;
    };
    UserAccountInfoBuilder.prototype.build = function () {
        return this.userAccountInfo;
    };
    return UserAccountInfoBuilder;
}());
export { UserAccountInfoBuilder };
//# sourceMappingURL=user-account-Info.builder.js.map